import Auth from "@aws-amplify/auth";

export async function Init(): Promise<void> {
  const config = {
    stage: "prod",
    aws_cognito_region: "ap-southeast-2",
    aws_cognito_identity_pool_id: "ap-southeast-2:9dc84fc9-6fcf-496b-8510-e20f44a1cce1",
    aws_user_pools_id: "ap-southeast-2_yvj1S1GtN",
    aws_user_pools_web_client_id: "3ubp3538qoqgbe4av5fsfuv7qf",
    Auth: {
      identityPoolId: "ap-southeast-2:9dc84fc9-6fcf-496b-8510-e20f44a1cce1",
      region: "ap-southeast-2",
      userPoolId: "ap-southeast-2_yvj1S1GtN",
      userPoolWebClientId: "3ubp3538qoqgbe4av5fsfuv7qf",
    },
    oauth: {
      domain: "whs-safer-prod-in.auth.ap-southeast-2.amazoncognito.com",
      redirectSignIn: "https://prod.in.safer.whs.amazon.dev",
      redirectSignOut: "https://prod.in.safer.whs.amazon.dev",
      scope: ["openid", "profile"],
      responseType: "code",
    },
  };
  Auth.configure(config);
}
